// src/firebase.js
// ─────────────────────────────────────────────────────────────
//  INSTRUCCIONES:
//  1. Ve a https://console.firebase.google.com
//  2. Crea un proyecto (o abre uno existente)
//  3. Ve a Configuración del proyecto > Tus apps > Agregar app Web (</>)
//  4. Copia los valores de firebaseConfig y pégalos aquí abajo
//  5. Activa Firestore: Build > Firestore Database > Create database
//     Elige modo "production" y selecciona tu región
// ─────────────────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            "AIzaSyBbiR1bsIhJnzmsLpBGl0mt-pANIxYkHaE",
  authDomain:        "importacionesgt-592f7.firebaseapp.com",
  projectId:         "importacionesgt-592f7",
  storageBucket:     "importacionesgt-592f7.firebasestorage.ap",
  messagingSenderId: "944606675692",
  appId:             "1:944606675692:web:7650e56d58c80e9f619bc9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
/*

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBbiR1bsIhJnzmsLpBGl0mt-pANIxYkHaE",
  authDomain: "importacionesgt-592f7.firebaseapp.com",
  projectId: "importacionesgt-592f7",
  storageBucket: "importacionesgt-592f7.firebasestorage.app",
  messagingSenderId: "944606675692",
  appId: "1:944606675692:web:7650e56d58c80e9f619bc9",
  measurementId: "G-BEF0M083DQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


*/